import "virtual:svg-icons-register"; //Here the svg sprite map has been generated
import _ from "underscore";
import "../css/main.scss";
import Vue from "vue";
import App from "./app.vue";
import { createStore } from "./store";
import { initMonitor } from "@klook/aff-monitor";
import { router } from "./router.js";
import { i18n, loadLanguageAsync } from "./i18n.js";
import klook from "klook";
import { formatPriceThousands, SUPPORT_CURRENCY_SYMBO } from "./utils";
import { use } from "echarts/core";
import ECharts from "vue-echarts";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart, LineChart } from "echarts/charts";
import ElementUI from 'element-ui';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
} from "echarts/components";

Vue.use(ElementUI);
Vue.component("v-chart", ECharts);

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  LineChart,
  PieChart,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  DataZoomComponent,
]);

// klook
window.klook = klook;
window._ = _;

initMonitor(Vue, "portal");

const store = createStore();

Vue.config.devtools = !klook.isProductionUrl();

Vue.filter("currencyToSymbol", (value) => {
  return SUPPORT_CURRENCY_SYMBO[value];
});

Vue.filter("formatPrice", (value: string | number) => {
  return formatPriceThousands(value);
});

loadLanguageAsync(window.KLK_LANG || "en").then(() => {
  new Vue({
    store,
    i18n,
    router: router,
    el: "#app",
    render: function (h: any) {
      return h(App);
    },
  });
});
